"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ButtonContainer = function ButtonContainer(_ref) {
  var _classNames, _classNames2;

  var className = _ref.className,
      dashed = _ref.dashed,
      disabled = _ref.disabled,
      fullWidth = _ref.fullWidth,
      highlight = _ref.highlight,
      icon = _ref.icon,
      browseIcon = _ref.browseIcon,
      light = _ref.light,
      loaderSize = _ref.loaderSize,
      loading = _ref.loading,
      onClick = _ref.onClick,
      title = _ref.title,
      type = _ref.type,
      value = _ref.value,
      displaySpanTag = _ref.displaySpanTag,
      props = _objectWithoutProperties(_ref, ["className", "dashed", "disabled", "fullWidth", "highlight", "icon", "browseIcon", "light", "loaderSize", "loading", "onClick", "title", "type", "value", "displaySpanTag"]);

  return displaySpanTag ? _react.default.createElement("span", _extends({
    "aria-label": value,
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, _style.default.button, true), _defineProperty(_classNames, _style.default._dashed, dashed), _defineProperty(_classNames, _style.default._fullWidth, fullWidth), _defineProperty(_classNames, _style.default._highlight, highlight), _defineProperty(_classNames, _style.default._icon, icon), _defineProperty(_classNames, _style.default._browseIcon, browseIcon), _defineProperty(_classNames, _style.default._light, light), _defineProperty(_classNames, _style.default._loading, loading), _defineProperty(_classNames, className, className), _classNames)),
    disabled: disabled || loading,
    onClick: onClick,
    title: title,
    type: type
  }, props), value, loading && _react.default.createElement("span", {
    className: _style.default.loader,
    style: {
      height: loaderSize,
      width: loaderSize
    }
  })) : _react.default.createElement("button", _extends({
    "aria-label": value,
    className: (0, _classnames.default)((_classNames2 = {}, _defineProperty(_classNames2, _style.default.button, true), _defineProperty(_classNames2, _style.default._dashed, dashed), _defineProperty(_classNames2, _style.default._fullWidth, fullWidth), _defineProperty(_classNames2, _style.default._highlight, highlight), _defineProperty(_classNames2, _style.default._icon, icon), _defineProperty(_classNames2, _style.default._browseIcon, browseIcon), _defineProperty(_classNames2, _style.default._light, light), _defineProperty(_classNames2, _style.default._loading, loading), _defineProperty(_classNames2, className, className), _classNames2)),
    disabled: disabled || loading,
    onClick: onClick,
    title: title,
    type: type
  }, props), value, icon && _react.default.createElement("svg", {
    style: {
      marginLeft: '7px'
    },
    width: "12",
    height: "13",
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    className: _style.default.pathfill,
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.5 12.2188C0.5 12.5553 0.772826 12.8281 1.10938 12.8281H11.4924C11.829 12.8281 12.1018 12.5553 12.1018 12.2188C12.1018 11.8822 11.829 11.6094 11.4924 11.6094H1.10938C0.772827 11.6094 0.5 11.8822 0.5 12.2188Z"
  }), _react.default.createElement("path", {
    className: _style.default.pathstroke,
    d: "M6.5 1L6.5 5L6.5 10.5",
    "stroke-linecap": "round"
  }), _react.default.createElement("path", {
    className: _style.default.pathstroke,
    d: "M10 6.5L6.5 10.5L3 6.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })), loading && _react.default.createElement("span", {
    className: _style.default.loader,
    style: {
      height: loaderSize,
      width: loaderSize
    }
  }));
};

ButtonContainer.defaultProps = {
  type: 'button'
};
var _default = ButtonContainer;
exports.default = _default;